/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useEffect, useState, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Grid, TextField } from '@material-ui/core';
import { Button } from 'react-bootstrap';
import SVGComponent from '../../../../SharedModules/SVGComponents/SVGComponents';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import RadioGroupComponent from '../../../../SharedModules/RadioGroup/RadioGroupBtn';
import SelectBoxComponent from '../../../../SharedModules/SelectBox/SelectBoxWithBox';
import {
  getFamilyPlanningDrugPmtRecData,
  getPlanTypeValues,
  getRebateProgrameList,
  setSearchInput,
} from '../Store/Actions';
import Spinner from '../../../../SharedModules/Spinner/Spinner';
import {
  autoFormateDate,
  tabHighLigther,
  validateDate,
} from '../../../../SharedModules/utilities/utilities';

import {
  compareDate,
  convertStringDate,
  quarterToDate,
  validateDateQuarter,
} from '../../../../SharedModules/utilities/dateUtilities';
import DisplayErrorMessages from '../../../../SharedModules/Errors/ErrorMessages';
import Fieldset from '../../../../SharedModules/Fieldset/Fieldset';
import {
  BEGIN_DATE,
  ENDDATE_REQUIRED,
  END_DATE_GREATER_THAN_START_DATE_FOR_CONTRACT,
  REBATE_SELECT,
  TO_DATE_GREATER_THAN_FROM,
} from '../../../../SharedModules/Errors/constantMessageData';
import { clearReduxForFilterAndSort } from '../../../../SharedModules/Table/store/Actions';

const ReqFamilyPlanningDrugsInv = (props) => {
  const dispatch = useDispatch();

  const {
    planType: planTypeList,
    errors,
    isLoading,
    selectedPlanType,
    rebateProgramValue,
    rebateProgramNameValue,
    rebateProgramList: rebateProgramListData,
    fromDateValue,
    toDateValue,
  } = useSelector(
    (state) => state?.sharedState?.FamilyPlanningDrugsPmtRecReducer
  );
  const getSearchResult = useSelector(
    (state) =>
      state?.sharedState?.FamilyPlanningDrugsPmtRecReducer?.searchResult
  );
  const userDefaults = useSelector(
    (state) => state?.sharedState?.UserDefaultReducer?.UserDefaultsValues?.data
  );

  const [radioList, setRadioList] = React.useState([]);

  const [selectList, setSelectList] = React.useState([]);

  const [planType, setPlanType] = React.useState(selectedPlanType);

  const [fromDate, setFromDate] = React.useState(fromDateValue);
  const [toDate, setToDate] = React.useState(toDateValue);
  const [isSearchClicked, setSearchClicked] = React.useState(false);

  const [rebateProgram, setRebateProgram] = React.useState(rebateProgramValue);

  const [rebateProgramName, setRebateProgramName] = React.useState(
    rebateProgramNameValue
  );

  const [errorList, setErrorList] = React.useState(errors);
  useEffect(() => {
    setErrorList(errors);
  }, [errors]);

  // After each time once plantype changes rebateprogram list get updated using this API call
  const rebatepgmDropdown = async (planType) => {
    const rebateProgramListData = await dispatch(
      getRebateProgrameList(planType)
    );
    const list = rebateProgramListData.map((val) => ({
      ...val,
      id: val.rebateProgramCd,
      name: `${val.rebateProgramCd} | ${val.shortDescr}`,
    }));
    // if (list.length) {
    setSelectList(list);
    const tempRebateProgram = list.find(
      (item) => item.id === userDefaults?.rebateProgramCd
    );
    setRebateProgram(rebateProgram || tempRebateProgram?.id || '-1');
    setRebateProgramName(tempRebateProgram?.name || '');
    // }
  };

  // on scroll default top level
  const handleScrollToEvent = () => {
    window.scrollTo(0, 0);
  };

  // After each time once plantype changes rebateprogram list get updated using this API call
  React.useEffect(() => {
    handleScrollToEvent();
    if (planType) {
      rebatepgmDropdown(planType);
      const errors = errorList?.filter((e) => e.field !== 'noData');
      setErrorList([...errors]);
    }
  }, [planType]);

  // set data for plan type radio list
  React.useEffect(() => {
    if (planTypeList?.PLAN_TYPE_CD?.length > 0) {
      const planList = planTypeList.PLAN_TYPE_CD.map((obj) => {
        return {
          name:
            obj.codeValueID.codeValue === 'FD'
              ? 'Medicaid'
              : obj.shortDescription,
          value: obj.codeValueID.codeValue,
        };
      });
      setRadioList([
        ...planList.filter((obj) => obj.name === 'Medicaid'),
        ...planList.filter((obj) => obj.name !== 'Medicaid'),
      ]);
      const tempPlanType = planList.find(
        (item) => item.value === userDefaults?.planTypeCd
      );
      setPlanType(planType || tempPlanType?.value);
    }
  }, [planTypeList]);

  // API to get the plan type list
  React.useEffect(() => {
    dispatch(getPlanTypeValues({ codeDomainList: ['PLAN_TYPE_CD'] }));
  }, []);

  //Resetting error message while input fields changed
  React.useEffect(()=>{
    dispatch(setSearchInput({ errors: [] }));
  }, [planType, rebateProgram, fromDate, toDate])
  // Highlights the tab if any error
  React.useEffect(() => {
    if (errorList.length > 0) {
      tabHighLigther('/familyPlanningDrugsPaymentReceived', true);
    } else {
      tabHighLigther('/familyPlanningDrugsPaymentReceived', false);
    }
  }, [JSON.stringify(errorList)]);

  // function to validate from Date and toDate on onblur
  const handleOnBlur = (type, input) => {
    const value = autoFormateDate(input);
    let allErrors = errorList;
    let fromError = [];
    let toError = [];

    if (type === 'fromDate') {
      setFromDate(value.toUpperCase());
      if (!value) fromError = [{ field: 'fromDate', message: BEGIN_DATE }];
      else if (value) fromError = validateDate(value, 'fromDate');
      allErrors = [...allErrors, ...fromError];
      if (!toDate && !fromError.length) {
        setToDate(value);
      }
    }
    if (type === 'toDate') {
      setToDate(value.toUpperCase());
      if (!value) fromError = [{ field: 'toDate', message: ENDDATE_REQUIRED }];
      else if (value) toError = validateDate(value, 'toDate');
      allErrors = [...allErrors, ...toError];
    }

    if (fromError.length === 0 && toError.length === 0) {
      if (compareDate(fromDate, toDate)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: TO_DATE_GREATER_THAN_FROM,
        });
      }
    }
    allErrors = [...allErrors];
    setErrorList(allErrors);
  };

  // Handle all the side effect on search button get clicked errorhandling and dispacting action and navigate to next screen

  /* istanbul ignore next */
  const handleSearchClick = () => {
    let allErrors = errorList;
    if (rebateProgram === '-1') {
      allErrors.push({
        field: 'rebateProgram',
        message: REBATE_SELECT,
      });
    }
    let fromError = [],
      toError = [];
    if (!fromDate) fromError = [{ field: 'fromDate', message: BEGIN_DATE }];
    else if (fromDate) fromError = validateDate(fromDate, 'fromDate');
    if (!toDate) toError = [{ field: 'toDate', message: ENDDATE_REQUIRED }];
    else if (toDate) toError = validateDate(toDate, 'toDate');
    if (fromError.length === 0 && toError.length === 0) {
      if (compareDate(fromDate, toDate)) {
        allErrors.push({
          field: 'fromDate>toDate',
          message: TO_DATE_GREATER_THAN_FROM,
        });
      }
    }
    allErrors = [...allErrors, ...fromError, ...toError];

    setErrorList(allErrors);
    // Variable to get fullname of rebate program from rebate program list(selectList)
    let rebateProgrameName =
      selectList.find((item) => item.rebateProgramCd === rebateProgram) || {};
    rebateProgrameName = `${rebateProgrameName?.rebateProgramCd} - ${
      rebateProgrameName?.shortDescr || ''
    }`;
    // setSearchClicked(true);
    dispatch(
      setSearchInput({
        fromDateValue: fromDate,
        toDateValue: toDate,
        errors: allErrors,
        selectedPlanType: planType,
        rebateProgramValue: rebateProgram,
        displayObj: {
          fromDateValue: fromDate,
          toDateValue: toDate,
          rebateProgrameName,
          selectedPlanType: planType,
          rebateProgramValue: rebateProgram,
          rebateProgramList: rebateProgramListData,
        },
      })
    );

    if (allErrors.length === 0) {
      setSearchClicked(true);

      let fromDateValue = fromDate;
      let toDateValue = toDate;
      if (fromDateValue.includes('Q')) {
        fromDateValue = convertStringDate(
          quarterToDate(fromDateValue, 'fromDate')
        );
      }
      if (toDateValue?.includes('Q')) {
        toDateValue = convertStringDate(quarterToDate(toDateValue, 'toDate'));
      }
      dispatch(
        getFamilyPlanningDrugPmtRecData({
          rebateProgram: rebateProgram,
          startDate: fromDateValue,
          endDate: toDateValue,
        })
      );
    }
  };
  if (isSearchClicked && getSearchResult?.length > 0) {
    setSearchClicked(false);
    props.history.push({
      pathname: '/DisplayFamilyPlanningDrugsPmtRec',
    });
    dispatch(clearReduxForFilterAndSort('/DisplayFamilyPlanningDrugsPmtRec'));
    const updateTabs =
      JSON.parse(localStorage.getItem('tabItemsData')) === null
        ? []
        : JSON.parse(localStorage.getItem('tabItemsData'));
    updateTabs.push({
      navTo: '/DisplayFamilyPlanningDrugsPmtRec',
      value: 'Display Family Planning Drugs Pmt Rec',
    });
    localStorage.setItem('tabItemsData', JSON.stringify(updateTabs));
  }

  const errorMessages = [...new Set(errorList?.map((obj) => obj.message))];

  return (
    <div className="tabs-container">
      <Spinner load={isLoading} />

      <CustomSeparator
        parent1="State Reports"
        parent2="Req Family Planning Drugs Pmt Rec"
      />

      <DisplayErrorMessages errorMessages={errorMessages.map((l) => l)} />

      <div className="tab-body" />
      <div className="row">
        <div className="col-4 frr-two-col-radio">
          <RadioGroupComponent
            data-testid="FamilyPlanningDrugsPmt-plan-type"
            id="filter-plan-by-radio-btn-action"
            labelName="Plan Type"
            required={false}
            optionList={radioList || []}
            defaultValue={planType}
            filterAction={(value) => {
              setPlanType(value);
              setRebateProgram('-1');
              const errors = errorList.filter(
                (error) => error.field !== 'rebateProgram'
              );
              setErrorList([...errors]);
            }}
            className="log-batch-filter-radio frr-checkInvoiceRadio"
          />
        </div>
        <div className="col-4">
          <>
            <Fieldset label="Rebate Program" required>
              <div style={{ marginTop: 18 }}>
                <SelectBoxComponent
                  data-testid="FamilyPlanning-rebate-program"
                  id="filter-plan-by-radio-btn-action"
                  labelName="Rebate Program"
                  required
                  select
                  selectOne
                  optionList={selectList || []}
                  defaultValue={rebateProgram}
                  filterAction={(value) => {
                    setRebateProgram(value);
                    setRebateProgramName(value);
                    const errors = errorList.filter(
                      (error) => error.field !== 'rebateProgram'
                    );
                    setErrorList([...errors]);
                  }}
                  isError={
                    errorList?.find((error) => error.field === 'rebateProgram')
                      ?.message
                  }
                />
              </div>
            </Fieldset>
          </>
        </div>
        <div className="col-4">
          <Fieldset label="Received Date Range">
            <div className="form-wrapper p-0 mt-n3">
              <div className="mui-custom-form input-md field-xl">
                <Grid container spacing={2}>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Begin"
                      id="Begin"
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      inputProps={{ maxLength: 10 }}
                      required
                      name="From"
                      value={fromDate}
                      error={
                        errorList.filter((error) => error.field === 'fromDate')
                          ?.length > 0
                          ? 'mandate-fields'
                          : ''
                      }
                      data-testid="FamilyPlanning-from-date"
                      helperText={
                        errorList.find((error) => error.field === 'fromDate')
                          ?.message
                      }
                      className="mandate-fields"
                      onBlur={(e) => handleOnBlur('fromDate', e.target.value)}
                      onChange={(e) => {
                        setFromDate(e.target.value.toUpperCase());
                        setErrorList([
                          ...errorList.filter(
                            (error) => error.field !== 'fromDate'
                          ),
                        ]);
                      }}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="End"
                      id="End"
                      data-testid="FamilyPlanning-to-date"
                      placeholder=""
                      InputLabelProps={{
                        shrink: true,
                      }}
                      required
                      inputProps={{ maxLength: 10 }}
                      name="to"
                      value={toDate}
                      onBlur={(e) => handleOnBlur('toDate', e.target.value)}
                      onChange={(e) => {
                        setToDate(e.target.value.toUpperCase());
                        setErrorList([
                          ...errorList.filter(
                            (error) =>
                              error.field !== 'toDate' &&
                              error.field !== 'fromDate>toDate'
                          ),
                        ]);
                      }}
                      error={
                        errorList.filter(
                          (error) =>
                            error.field === 'toDate' ||
                            error.field === 'fromDate>toDate'
                        )?.length > 0
                          ? 'mandate-fields'
                          : ''
                      }
                      helperText={
                        errorList.find(
                          (error) =>
                            error.field === 'toDate' ||
                            error.field === 'fromDate>toDate'
                        )?.message
                      }
                      className="mandate-fields"
                    />
                  </Grid>
                </Grid>
              </div>
            </div>
          </Fieldset>
        </div>
      </div>
      <div className="row" style={{ marginTop: 30 }}>
        <div className="btn-wrapper col-12">
          <Button
            data-testid="FamilyPlanningDrug-search-btn"
            onClick={handleSearchClick}
            className="btn btn-success btn-search float-right"
          >
            <SVGComponent iconName="Icon-search" /> Search
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ReqFamilyPlanningDrugsInv;
